import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { sharedReportDataFromNoVersionToOnePointOh } from './shared-report-data-version-1.0';
import { sharedReportDataFromOnePointOhToOnePointOne } from './shared-report-data-version-1.1';
import { sharedReportDataFromOnePointOneToTwoPointOh } from './shared-report-data-version-2.0';
import { sharedReportDataFromTwoPointOhToTwoPointOne } from './shared-report-data-version-2.1';
import { sharedReportDataFromTwoPointOneToTwoPointTwo } from './shared-report-data-version-2.2';
import { sharedReportDataFromTwoPointTwoToTwoPointThree } from './shared-report-data-version-2.3';


export type SharedReportDataVersion = '0.0' | '1.0' | '1.1' | '2.0' | '2.1' | '2.2'| '2.3';
type SharedReportDataTransformationFunction = (oldDataModel: BlockModel, data: any) => BlockModel;
const currentChartBlockVersion = '2.3';

export class SharedReportDataVersioner {

    static readonly transformationJumpTable: { [k in SharedReportDataVersion]?: SharedReportDataTransformationFunction } = {
        ['0.0']: sharedReportDataFromNoVersionToOnePointOh,
        ['1.0']: sharedReportDataFromOnePointOhToOnePointOne,
        ['1.1']: sharedReportDataFromOnePointOneToTwoPointOh,
        ['2.0']: sharedReportDataFromTwoPointOhToTwoPointOne,
        ['2.1']: sharedReportDataFromTwoPointOneToTwoPointTwo,
        ['2.2']: sharedReportDataFromTwoPointTwoToTwoPointThree
    };

    static transformDataToNewestVersion(oldDataModel: BlockModel, data: any): void {
        let currentData: BlockModel = oldDataModel;
        while (this.versionAsNumber(currentData) < this.versionAsNumber(currentChartBlockVersion)) {
            currentData = this.transformationJumpTable[this.getVersion(currentData)](currentData, data);
        }
    }

    static versionAsNumber(modelOrVersion: BlockModel | SharedReportDataVersion): number {
        if (typeof modelOrVersion === 'object') {
            const version = this.getVersion(modelOrVersion);
            return Number(version);
        }

        return Number(modelOrVersion);
    }

    static getVersion(model: BlockModel): SharedReportDataVersion {
        return model['version'] ?? '0.0';
    }
}
